import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  VStack,
  Box,
} from "@chakra-ui/react";
import React from "react";

interface SaveChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isProcessing: boolean;
  date: string;
  originalDate: string;
  time: string;
  originalTime: string;
  procedures: any[];
  totalCost: number;
}

const SaveChangesModal: React.FC<SaveChangesModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isProcessing,
  date,
  originalDate,
  time,
  originalTime,
  procedures,
  totalCost,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Save Changes</ModalHeader>
        <Box borderBottom="1px solid #E7E8EB" mx={{ base: 4, md: 6 }} />
        <ModalBody>
          <VStack spacing={3} align="stretch">
            <Text>Are you sure you want to save these changes?</Text>

            {(date !== originalDate || time !== originalTime) && (
              <Box bg="blue.50" p={3}>
                <Text fontWeight="semibold">Schedule Changes:</Text>
                {date !== originalDate && (
                  <Text fontSize="sm">
                    Date: {originalDate} → {date}
                  </Text>
                )}
                {time !== originalTime && (
                  <Text fontSize="sm">
                    Time: {originalTime} → {time}
                  </Text>
                )}
              </Box>
            )}

            {procedures.length > 0 && (
              <Box bg="green.50" p={3} borderRadius="md">
                <Text fontWeight="semibold">Procedure Changes:</Text>
                <Text fontSize="sm">
                  {procedures.length} procedure(s) added/updated
                </Text>
                <Text fontSize="sm">Total Cost: ₱{totalCost.toFixed(2)}</Text>
              </Box>
            )}
          </VStack>
        </ModalBody>
        <Box borderBottom="1px solid #E7E8EB" mx={{ base: 4, md: 6 }} />
        <ModalFooter>
          <Button
            variant="ghost"
            mr={3}
            onClick={onClose}
            isDisabled={isProcessing}
          >
            Cancel
          </Button>
          <Button
            bg="#DC3611"
            _hover={{ bg: "#bf3c1fff" }}
            color="white"
            onClick={onConfirm}
            isLoading={isProcessing}
            loadingText="Saving..."
          >
            Save Changes
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SaveChangesModal;
